export const typeMapper = {
  DEAL: 'Opportunities',
  PROPOSAL: 'Proposals',
  REPORT: 'Lists',
  COMPANY: 'Companies',
  CONTACT: 'Contacts'
}

export const urlMapper = {
  DEAL: '/opportunities/',
  PROPOSAL: '/proposals/',
  REPORT: '/lists/',
  COMPANY: '/companies/',
  CONTACT: '/contacts/'
}
